import { useDispatch } from 'react-redux';
import { createAndAddToWishlist } from '@client/myAccount/wishlists/redux/wishlist/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useCreateAndAddToWishlistAction = (): typeof createAndAddToWishlist => {
  const dispatch = useDispatch();

  return bindActionCreators(createAndAddToWishlist, dispatch);
};
